import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { FloatingActions } from "@/components/CTA";
import Home from "@/pages/Home";
import Nutrizione from "@/pages/Nutrizione";
import Allenamento from "@/pages/Allenamento";
import Integrati from "@/pages/Integrati";
import ChiSono from "@/pages/ChiSono";
import Recensioni from "@/pages/Recensioni";
import Contatti from "@/pages/Contatti";
import Legal from "@/pages/Legal";
import CookieConsent from "@/components/CookieConsent";
import { trackPageView } from "@/lib/analytics";

const ScrollReset = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    trackPageView(pathname);
  }, [pathname]);
  return null;
};

export default function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09 });
    let frame;
    const loop = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(loop);
    };
    frame = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollReset />
      <div className="min-h-screen overflow-x-clip bg-paper text-ink">
        <Navbar />
        <main className="pb-[76px] md:pb-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nutrizione" element={<Nutrizione />} />
            <Route path="/allenamento" element={<Allenamento />} />
            <Route path="/nutrizione-allenamento-integrati" element={<Integrati />} />
            <Route path="/chi-sono" element={<ChiSono />} />
            <Route path="/recensioni" element={<Recensioni />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/privacy-policy" element={<Legal title="Privacy Policy" kind="privacy" />} />
            <Route path="/cookie-policy" element={<Legal title="Cookie Policy" kind="cookie" />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <FloatingActions />
        <CookieConsent />
      </div>
    </BrowserRouter>
  );
}
